import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentDetailResponse, fetchETFDetail } from "@features/investments/api";

export const etfDetailQueryKey = (ticker: string) => ["investments", "etf-detail", ticker] as const;

export function useETFDetailQuery(ticker: string, enabled = true): UseQueryResult<InvestmentDetailResponse, Error> {
  return useQuery({
    queryKey: etfDetailQueryKey(ticker),
    queryFn: () => fetchETFDetail(ticker),
    enabled: enabled && ticker.trim() !== "",
    retry: false,
  });
}
